<!-- frontend/src/App.vue -->
<template>

  <header>
    <div class="container">
      <h1>vDrive</h1>
      <p>Secure File Exchange Platform</p>
      <nav>
        <router-link to="/">Upload File</router-link>
        <router-link to="/download">Download Private File</router-link>
      </nav>
    </div>
  </header>
  <main class="container">
    <router-view/>
  </main>
</template>


<script>
export default {
  name: 'App'
}
</script>

<style>
body, html {
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  background: #f0f4f8;
  color: #333;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

header {
  background: #2c3e50;
  color: white;
  padding: 20px 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

h1 {
  margin: 0;
  font-size: 2.5em;
}

nav {
  margin-top: 20px;
}

nav a {
  color: white;
  text-decoration: none;
  margin-right: 20px;
  font-size: 1.2em;
}

.file-drop-zone {
  border: 3px dashed #3498db;
  border-radius: 10px;
  padding: 40px;
  text-align: center;
  background: white;
  transition: all 0.3s ease;
  margin-top: 40px;
}

.file-drop-zone:hover {
  background: #ecf0f1;
  cursor: pointer;
}

.file-list {
  margin-top: 40px;
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.file-item-field {
  margin-bottom: 10px;
}
.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: column;
  flex-wrap: wrap;
  border-bottom: 1px solid #eee;
}

.file-item:last-child {
  border-bottom: none;
}

.btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.btn:hover {
  background: #2980b9;
}

.download-form, .view-form {
  margin-top: 40px;
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

input[type="text"], input[type="password"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.progress-bar {
  margin-top: 20px;
  height: 20px;
  background: #f0f4f8;
  border-radius: 10px;
  overflow: hidden;
}

.progress {
  height: 100%;
  background: #3498db;
  transition: width 0.3s ease;
}
/* Добавьте стили для прогресс-бара */
#nprogress .bar {
  background: #29d;
}

#nprogress .peg {
  box-shadow: 0 0 10px #29d, 0 0 5px #29d;
}

#nprogress .spinner-icon {
  border-top-color: #29d;
  border-left-color: #29d;
}
.checkbox-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}



.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  user-select: none;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #d9d6d6;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #2196F3;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

</style>
